import { render } from "./JourneyButton.vue?vue&type=template&id=f8c55e36&scoped=true"
import script from "./JourneyButton.vue?vue&type=script&lang=js"
export * from "./JourneyButton.vue?vue&type=script&lang=js"

import "./JourneyButton.vue?vue&type=style&index=0&id=f8c55e36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c55e36"]])

export default __exports__